module.exports = __webpack_public_path__ + "img/img86.675182de.png";